import React, { useState, useEffect } from 'react'
import useTranslate from '../hooks/useTranslate'
import { Link } from 'react-router-dom'
import { IoClose } from 'react-icons/io5'
import { FaSearch } from 'react-icons/fa'

const CropDrawer = ({ isOpen, onClose, crops }) => {
    const [searchTerm, setSearchTerm] = useState('')

    const t = useTranslate({
        crop: "Crop",
        smartGuide: "Smart Guide",
        info: "Info",
    });

    useEffect(() => {
        if (isOpen) {
            window.__activeModals = (window.__activeModals || 0) + 1;
            document.body.style.overflow = 'hidden';
        } else {
            if (window.__activeModals > 0) {
                window.__activeModals = (window.__activeModals || 0) - 1;
            }
            if (window.__activeModals <= 0) {
                document.body.style.overflow = 'unset';
                window.__activeModals = 0;
            }
            setSearchTerm('');
        }
        return () => {
            if (isOpen) {
                window.__activeModals = (window.__activeModals || 0) - 1;
                if (window.__activeModals <= 0) {
                    document.body.style.overflow = 'unset';
                    window.__activeModals = 0;
                }
            }
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const filteredCrops = crops.filter(crop =>
        crop.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleClose = () => {
        setSearchTerm('');
        onClose();
    };

    return (
        <div className='fixed inset-0 z-[100] flex justify-end bg-black/40 backdrop-blur-[2px] transition-all animate-fadeIn'>
            {/* Backdrop */}
            <div className='flex-1' onClick={handleClose} aria-hidden="true"></div>

            {/* Drawer Content */}
            <div className='bg-white h-full w-full max-w-[800px] shadow-2xl flex flex-col animate-slideInRight overflow-hidden relative'>
                {/* Header */}
                <div className='p-6 border-b border-gray-100 flex flex-col sm:flex-row sm:items-center justify-between gap-4 bg-white sticky top-0 z-10'>
                    <div className='flex items-center gap-4'>
                        <button
                            onClick={handleClose}
                            className='p-2 text-gray-500 hover:text-red-500 hover:bg-gray-100 rounded-lg transition-colors'
                        >
                            <IoClose size={22} />
                        </button>
                        <h2 className='text-2xl font-black text-slate-800 uppercase tracking-tight'>
                            {t.crop} <span className='text-[#00b259]'>{t.smartGuide}</span>
                        </h2>
                    </div>

                    {/* Search bar */}
                    {/* <div className='relative w-full sm:max-w-xs'>
                        <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400'>
                            <FaSearch size={14} />
                        </div>
                        <input
                            type='text'
                            placeholder='Search crops...'
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className='w-full pl-9 pr-4 py-2 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-[#00b259] transition-colors bg-slate-50 focus:bg-white'
                        />
                    </div> */}
                </div>

                <div className='flex-1 overflow-y-auto p-6 bg-[#f8fcfb]'>
                    {filteredCrops.length > 0 ? (
                        <div className='grid grid-cols-4 sm:grid-cols-4 gap-2 sm:gap-6 justify-items-center'>
                            {filteredCrops.map((crop) => (
                                <div key={crop.id} onClick={handleClose}>
                                    <Link
                                        to={`/crop/${crop.id}`}
                                        className='flex flex-col items-center group cursor-pointer w-fit'
                                    >
                                        <div className='relative w-16 h-16 sm:w-24 sm:h-24 rounded-full p-1 bg-white border border-gray-100 shadow-md flex items-center justify-center transition-all group-hover:border-[#00b259]/30 group-hover:shadow-lg'>
                                            <img
                                                src={crop.image}
                                                alt={crop.name}
                                                className='w-full h-full object-cover rounded-full'
                                                onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?w=400' }}
                                            />
                                            <div className='absolute inset-0 bg-black/40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center'>
                                                <span className='text-[8px] sm:text-[9px] font-black text-white uppercase tracking-widest'>{t.info}</span>
                                            </div>
                                        </div>
                                        <h3 className='mt-2 text-[10px] sm:text-xs font-black text-slate-600 group-hover:text-[#00b259] transition-colors uppercase tracking-[1px] text-center line-clamp-1'>
                                            {crop.name}
                                        </h3>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className='flex flex-col items-center justify-center py-20 text-slate-400'>
                            <p className='text-lg font-black uppercase tracking-widest mb-2'>No Crops Found</p>
                            <p className='text-xs'>Try searching for a different crop name.</p>
                        </div>
                    )}
                </div>
            </div>

            <style jsx="true">{`
                .animate-fadeIn { animation: fadeIn 0.3s ease-out forwards; }
                .animate-slideInRight { animation: slideInRight 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes slideInRight { from { transform: translateX(100%); } to { transform: translateX(0); } }
            `}</style>
        </div>
    )
}

export default CropDrawer
